import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class BrandDirectory extends ThemeComponent {
    @Ref() linksContainer!: HTMLElement;
    @Ref() links!: HTMLButtonElement[];

    init() {
        // Init links click event listener
        if (this.links) {
            for (const link of this.links) {
                this.$listen(link, 'click', () => this.handleLinkClick(link));
            }
        }

        // Handle sticky links container
        if (this.linksContainer) {

            // Get element top position
            const topPosition = this.linksContainer.offsetTop;

            // Init scroll event listener and initial call
            this.$listen(window, 'scroll', () => this.handleScroll(topPosition));
            this.handleScroll(topPosition);
        }
    }

    handleLinkClick(element: HTMLButtonElement) {
        // Get target ID
        const targetId = element.getAttribute('data-target');
        if (!targetId) {
            return;
        }

        // Get section
        const sectionToScrollTo = document.getElementById(`${targetId}`);
        if (!sectionToScrollTo) {
            return;
        }

        // Get header
        const header = document.querySelector('.header');
        if (!header) {
            return;
        }

        // Scroll to element
        const elementRect = sectionToScrollTo.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.scrollY;
        const middle = absoluteElementTop - (window.innerHeight / 2);
        window.scroll({
            top: middle,
            left: 0,
            behavior: 'smooth'
        });

        // Handle focus class
        setTimeout(() => {
            sectionToScrollTo.classList.add('brand-directory__section--focused');

            setTimeout(() => {
                sectionToScrollTo.classList.remove('brand-directory__section--focused');
            }, 1000);
        }, 500);
    }

    handleScroll(topPosition: number) {

        // Check device width as we only want sticky styles for desktop
        if (window.innerWidth <= 700) {

            // Remove sticky class
            this.linksContainer.classList.remove('brand-directory__links--sticky');

            // Move content back
            this.style.paddingTop = `${0}px`;

            // Do not continue
            return;
        }

        // Only overwrite value if the element is not sticky
        if (this.linksContainer.offsetTop !== 0) {
            topPosition = this.linksContainer.offsetTop;
        }

        // Check if we have scrolled to the element
        if (window.scrollY >= topPosition) {

            // Add sticky class
            this.linksContainer.classList.add('brand-directory__links--sticky');

            // Push content down
            this.style.paddingTop = `${this.linksContainer.offsetHeight}px`;
        } else {

            // Remove sticky class
            this.linksContainer.classList.remove('brand-directory__links--sticky');

            // Move content back
            this.style.paddingTop = `${0}px`;
        }
    }
}
